import { render, staticRenderFns } from "./GridGallery.vue?vue&type=template&id=9975b516&scoped=true&"
import script from "./GridGallery.vue?vue&type=script&lang=js&"
export * from "./GridGallery.vue?vue&type=script&lang=js&"
import style0 from "./GridGallery.vue?vue&type=style&index=0&id=9975b516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9975b516",
  null
  
)

export default component.exports